/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:c8f64552-2992-4bc2-8cb6-22b0a2ccc160",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_q5JOMQ3hc",
    "aws_user_pools_web_client_id": "6p2q8oleics2rok04dkehdae1j",
    "oauth": {
        "scope": [
            "aws.cognito.signin.user.admin",
            "openid",
            "profile"
        ],
        "redirectSignIn": "https://dashboards.app.sbaunifiedlending.com",
        "redirectSignOut": "https://dashboards.app.sbaunifiedlending.com",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 12,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": []
};


export default awsmobile;
